import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitQbrDocuments = createSelector(
  selectFinancialCockpitState,
  ({ qbrDocuments }) => qbrDocuments
)
